import HoverableButton from '@/atomic-components/Buttons/Hoverable';
import FlexBox from '@/atomic-components/FlexBox';
import LencoButton from '@/atomic-components/LencoButton';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';

export enum PrimaryActionButtonStates {
	ADD_TO_CART = 'ADD_TO_CART',
	GO_TO_CART = 'GO_TO_CART',
	OUT_OF_STOCK = 'OUT_OF_STOCK',
}

interface AddToCartButtonProps {
	leftLabel: string;
	isLoading: boolean;
	onClick: () => void;
}

interface GoToCartButtonProps {
	leftLabel: string;
	onClick: () => void;
}

interface OutOfStockButtonProps {
	leftLabel: string;
}

export const AddToCartButton = (props: AddToCartButtonProps) => (
	<HoverableButton
		id='add_to_cart'
		leftLabel={props.leftLabel}
		rightLabel='ADD TO CART'
		leftLabelProps={{
			sx: getStyle('H14_SemiBold'),
		}}
		rightLabelProps={{
			sx: { ...getStyle('H14_SemiBold'), whiteSpace: 'nowrap' },
		}}
		onClick={props.onClick}
		isLoading={props.isLoading}
	/>
);

export const GoToCartButton = (props: GoToCartButtonProps) => {
	return (
		<HoverableButton
			id='go_to_cart'
			leftLabel={props.leftLabel}
			rightLabel='GO TO CART'
			leftLabelProps={{
				sx: getStyle('H14_SemiBold'),
			}}
			rightLabelProps={{
				sx: { ...getStyle('H14_SemiBold'), whiteSpace: 'nowrap' },
			}}
			onClick={props.onClick}
		/>
	);
};

export const OutOfStockButton = (props: OutOfStockButtonProps) => {
	return (
		<LencoButton
			color='error'
			variant='contained'
			id='pdp-out_of_stock'
			onClick={() => null}
			fullWidth
			sx={{
				backgroundColor: getColor('Danger -2'),
				p: '16px 24px',
				borderRadius: '24px',
			}}
		>
			<FlexBox fullWidth justifyContent='space-between'>
				<LencoTypography variant='H14_SemiBold'>
					{props.leftLabel}
				</LencoTypography>
				<LencoTypography variant='H14_SemiBold'> &nbsp;Out of Stock</LencoTypography>
			</FlexBox>
		</LencoButton>
	);
};
